import React, { LegacyRef, ReactNode } from "react";

type FilterWrapTypes = {
  className?: string;
  children?: ReactNode;
};

const FilterWrap = ({ className, children }: FilterWrapTypes) => {
  return <div className={className}>{children}</div>;
};
export default FilterWrap;
